import Event = createjs.Event;

export class BasicComboboxEvent extends Event {
    public static COMBOBOXCHANGE: string = "comboboxchange";
    public static COMBOBOXSELECT: string = "comboboxselect";

    public state: number = 0;
    public userHasSelected: boolean = false;

    constructor(type: string, state: number = 0, bubbles: boolean = false, cancelable: boolean = false, userHasSelected: boolean = false) {
        super(type, bubbles, cancelable);

        this.state = state;
        this.userHasSelected = userHasSelected;
    }
}
